import AxiosService from "./axiosServices";
const axiosService = new AxiosService();

export default class ValidationService {
  getValiData = (projectId, batchId, forValue) => {
    const formattedValue = forValue === "viewOnly" ? "view_only" : forValue;
    return axiosService.Get(
      `api/cam/review-validated-data/${batchId}/?data_for=${formattedValue}`,
    );
  };

  isSignatureUploaded = () => {
    return axiosService.Get(`api/cam/is-signature-uploaded/`);
  };

  getBatchDetailsList = (data) => {
    const { type, formattedStartDate, formattedEndDate, status, reviewFor } =
      data;
    let params = {};
    let boolStatus = "";
    if (type === "project") {
      params = {
        created_project_after: formattedStartDate,
        created_project_before: formattedEndDate,
        review_for: reviewFor,
        drug_type: data?.drugType,
        project_name: data?.searchText,
        // type: type,
        page: data?.page,
        page_size: data?.page_size,
      };
    } else {
      params = {
        created_batch_after: formattedStartDate,
        created_batch_before: formattedEndDate,
        validation_review_status: status,
        review_for: reviewFor,
        drug_type: data?.drugType,
        batch_name: data?.searchText,
        // type: type,
        page: data?.page,
        page_size: data?.page_size,
      };
    }
    // params = {
    //   created_batch_after: formattedStartDate,
    //   created_batch_before: formattedEndDate,
    //   validation_review_status: boolStatus,
    // };

    return axiosService.Get("api/cam/list-batches-to-review/", {
      params: params,
      // params: {
      //   page_size: data?.page_size,
      //   page: data?.page,
      //   // search: data?.search || "",
      // },
    });
  };

  esignHandle = (userName, userId, userRole, userPassword) => {
    const data = {
      body: {
        user_name: userName,
        user_id: userId,
        user_role: userRole,
        user_password: userPassword,
      },
    };
    return axiosService.Post(`api/cam/verify-user/`, data);
  };

  rejectValidatorData = (payloadData) => {
    const data = {
      body: payloadData,
    };

    return axiosService.Post(`api/cam/reject-validation/`, data);
  };

  validateData = (payloadData) => {
    const data = {
      body: payloadData,
    };

    return axiosService.Post(`api/cam/submit-validation-review/`, data);
  };
}
